import React from 'react'
import './site.css'

export default class Site extends React.Component {
  constructor(props) {
    super(props)
  }
  render() {
    const { tel, dir, dep, mun } = this.props;
    return (
      <div className="site">
        <div>
          {mun} - {dep}
        </div>
        <div>
          {dir}
        </div>
        <div>
          Teléfono: {tel}
        </div>

      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/sites/Site.jsx